import { mutation, query } from "@core/helpers/graphql";
import { CANCEL_FORM_SUBMISSION, CREATE_FORM_SUBMISSION, SAVE_FORM_PROGRESS } from "./_mutations";
import { GET_MY_FORM_SUBMISSION } from "./_queries";

// variables: { input: { form_definition_id | form_key, version, values, meta, captcha } }
export const create_form_submission_mutation = async (variables, options = {}) => {
    const { gql } = options;
    const result = await mutation(gql || CREATE_FORM_SUBMISSION, variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

// variables: { input: { form_definition_id | form_key, version, step, values } } - the step the visitor is on and the values so far (no file)
export const save_form_progress_mutation = async (variables, options = {}) => {
    const { gql } = options;
    const result = await mutation(gql || SAVE_FORM_PROGRESS, variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

// variables: { form_definition_id } or { form_key }. data is null for a guest and for a visitor with no row in the form.
export const get_my_form_submission_query = async (variables, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_MY_FORM_SUBMISSION, variables, { fetchPolicy: "network-only", ...options });
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

// variables: { input: { form_definition_id | form_key, submission_id? } } - the visitor's own draft is given the status deleted; a sent answer is refused
export const cancel_form_submission_mutation = async (variables, options = {}) => {
    const { gql } = options;
    const result = await mutation(gql || CANCEL_FORM_SUBMISSION, variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};
